import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicNavbar from '../components/nav/PublicNavbar';
import PublicLegalFooter from '../components/footer/PublicLegalFooter';

const AUTH_ROUTES = ['/signup', '/signin', '/login', '/worker-invite'];

const PublicLayout: React.FC = () => {
  const location = useLocation();
  const isAuthRoute = AUTH_ROUTES.some(
    (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
  );

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <PublicNavbar />
      <main className={`flex-grow flex flex-col min-h-0 ${isAuthRoute ? 'pb-28' : ''}`}>
        <Outlet />
      </main>
      <div className={isAuthRoute ? 'fixed left-0 right-0 bottom-0 z-40' : ''}>
        <PublicLegalFooter />
      </div>
    </div>
  );
};

export default PublicLayout;
